import { useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import TaskItem from '@tiptap/extension-task-item';
import TaskList from '@tiptap/extension-task-list';
import { formatDateRange } from '../../../utilities/format-date';
import ExpandableCard from '../../../common/expandable-card/ExpandableCard';
import { InlineExternalLink } from '@monash/portal-react';
import RichTextEditor from '../../../common/rich-text-editor/RichTextEditor';
import { UPDATE_STATUSES } from '../constants';
import c from './update-card.module.scss';

const UpdateCard = ({ update, open, slide, openSlideForm }) => {
  const {
    id,
    description,
    startDate,
    endDate,
    publishDate,
    status,
    userGroups,
    ...restUpdate
  } = update;
  const dateRange = formatDateRange(startDate, endDate);
  const cohorts = userGroups
    .map((group) => `${group.code} - ${group.name}`)
    .join(', ');
  const label = (
    <>
      {dateRange ? (
        <>
          {dateRange}
          <br />
        </>
      ) : null}
      Published to: {cohorts}
    </>
  );

  const editor = useEditor(
    {
      editable: false,
      extensions: [
        StarterKit,
        Document,
        TaskList,
        TaskItem.configure({ nested: false }),
      ],
      content: description,
    },
    [description]
  );

  if (!editor) return null;

  return (
    <ExpandableCard
      onClick={() => openSlideForm(update)}
      expandedContent={
        <div className={c.updateCardContainer}>
          <RichTextEditor value={description} display={true} disabled={true} />
          {update.links?.length ? (
            <div className={c.links}>
              {update.links.map(({ label, url }) => {
                const textLabel = label || url;
                return (
                  <InlineExternalLink link={url} text={textLabel} key={label} />
                );
              })}
            </div>
          ) : null}
        </div>
      }
      label={label}
      selected={open && slide?.data?.id === id}
      publishDate={status === UPDATE_STATUSES.SCHEDULED && publishDate}
      status={status}
      labelLineBreak={false}
      {...restUpdate}
    />
  );
};

export default UpdateCard;
